import RegisterValidateLayout from 'presentation/patient/layouts/RegisterValidate'
import React from 'react'

export default function RegisterValidate() {
  return <RegisterValidateLayout />
}
